<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="pagevii"></a>
<p class="dedicationText">This book is dedicated to my mother, Carol, who passed away during the final edits. She is sorely missed.</p>
<p class="dedicationText">To my daughters, and lights of my life, Joelle Rebecca and Emma Grace.</p>
<p class="dedicationText">And, to the 100,000s of newbies who I’ve had the pleasure of working with at <a href="http://trendfund.com" target="_blank">trendfund.com</a> and Trend Trading to Win, all of us searching for ways to a better life in this crazy world. Peace and prosperity to all.</p>
<a id="pageviii"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ruleyourfreakinretirement_ded01.vue?209538ef